export default {
  section_title: 'Monedă',
  label: 'Monedă',
  tooltip:
    'Moneda folosită pentru prețuri, plăți și rapoarte. Este setată pentru contul tău de partener la creare și nu poate fi modificată aici — contactează asistența dacă este greșită.',
  from_your_partner: 'De la partenerul tău',
  set_for_your_account: 'Setată pentru contul tău',
};
